import React from 'react'

import { useModal } from '@context/ModalsContext'
import { useProductReadContext } from '@context/ProductContext'

import { CarouselProvider } from '@ui/Carousel/CarouselProvider'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { GuideTypes } from '@model/ClientGuideDto'

import {
  CheckEmailInstructionsCarouselChild,
  CongratulationsCarouselChild,
  FundYourWalletCarouselChild,
  SubscribeToMarketDataCarouselChild,
  SubscribeToTradingPlatformCarouselChild,
  TransferFundsFromWalletToTradingAccountCarouselChild,
} from '@shared/components/FirstTimeGuideCarousel/FirstTimeGuideCarouselChild'
import { GuideConfirmationModal } from '@shared/components/FirstTimeGuideCarousel/modals/GuideConfirmationModal'

import styles from './FirstTimeGuide.module.scss'

interface FirstTimeGuideCarouselProps {
  onConfirmationModalOpen(): void
}

interface FirstTimeGuideCarouselCFDProps {
  reloadGuide(): void
  handleDeposit: () => void
}

export const FirstTimeGuideCarouselETD = (props: FirstTimeGuideCarouselCFDProps) => {
  const apiClient = useApiClient(ClientApiClient)
  const { product } = useProductReadContext()
  const { handleDeposit } = props

  const handleGuideDismiss = async () => {
    await apiClient.updateClientGuideDismiss(GuideTypes.IntroductionGuide, {
      tickmillProductId: product,
    })
    props.reloadGuide()
    closeGuideModal.close()
  }

  const closeGuideModal = useModal(GuideConfirmationModal, { onGuideClose: handleGuideDismiss })

  const carousels = [
    { component: <FundYourWalletCarouselChild onDeposit={handleDeposit} /> },
    { component: <TransferFundsFromWalletToTradingAccountCarouselChild /> },
    { component: <SubscribeToTradingPlatformCarouselChild /> },
    { component: <SubscribeToMarketDataCarouselChild /> },
    { component: <CheckEmailInstructionsCarouselChild /> },
    { component: <CongratulationsCarouselChild /> },
  ]

  const carouselSettings = {
    hideDots: true,
    interval: 5000,
    items: carousels,
    loop: false,
  }

  return (
    <div className={styles.wrapper}>
      <CarouselProvider<FirstTimeGuideCarouselProps>
        {...carouselSettings}
        onConfirmationModalOpen={closeGuideModal.open}
      />
    </div>
  )
}
